import Table from './Table'
import DataTable from './DataTable'

export default Table
export { DataTable }